// react
import React from "react";

// styling
import "./ProgressBar.scss";

const ProgressBar = (props) => {
  const {page, numOfPage} = props;
  return (
    <ul className="progressbar">
      {Array(numOfPage).fill().map((value, index) => {
        let className;
        if (index++ < page) {
          className = "passed"
        }
        if (index++ === page) {
          className = "active"
        }        
        return <li key={index} className={className}></li>
      })}
    </ul>
  );
};

export default ProgressBar;



    

